/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */
"use strict";

var _objectSpread = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _toConsumableArray = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function peg$subclass(child, parent) {
  function ctor() {
    this.constructor = child;
  }

  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function (expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function literal(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },
    "class": function _class(expectation) {
      var escapedParts = "",
          i;

      for (i = 0; i < expectation.parts.length; i++) {
        escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
      }

      return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
    },
    any: function any(expectation) {
      return "any character";
    },
    end: function end(expectation) {
      return "end of input";
    },
    other: function other(expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function classEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i,
        j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }

      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},
      peg$startRuleFunctions = {
    statements: peg$parsestatements
  },
      peg$startRuleFunction = peg$parsestatements,
      peg$c0 = function peg$c0(head, tail) {
    return buildList(head, tail, 1);
  },
      peg$c1 = function peg$c1(insn) {
    return insn;
  },
      peg$c2 = function peg$c2(label, scopedStmts) {
    return ast.mkAsmLine(label, null, scopedStmts, loc());
  },
      peg$c3 = function peg$c3(label, stmt) {
    return ast.mkAsmLine(label, stmt, null, loc());
  },
      peg$c4 = function peg$c4(label) {
    return ast.mkAsmLine(label, null, null, loc());
  },
      peg$c5 = function peg$c5(stmt) {
    return ast.mkAsmLine(null, stmt, null, loc());
  },
      peg$c6 = function peg$c6(pc) {
    return ast.mkAsmLine(null, pc, null, loc());
  },
      peg$c7 = function peg$c7() {
    // empty line is a no-op
    return ast.mkAsmLine(null, null, null, loc());
  },
      peg$c8 = function peg$c8(directive) {
    return directive;
  },
      peg$c9 = function peg$c9(instruction) {
    return ast.mkInsn(instruction, loc());
  },
      peg$c10 = ":",
      peg$c11 = peg$literalExpectation(":", false),
      peg$c12 = function peg$c12(lbl) {
    return ast.mkLabel(lbl, loc());
  },
      peg$c13 = function peg$c13(pc) {
    return ast.mkSetPC(pc, loc());
  },
      peg$c14 = function peg$c14(size, values) {
    var dataSize = size == 'byte' ? ast.DataSize.Byte : ast.DataSize.Word;
    return ast.mkData(dataSize, values, loc());
  },
      peg$c15 = function peg$c15(numBytes, fillValue) {
    return ast.mkFill(numBytes, fillValue, loc());
  },
      peg$c16 = function peg$c16(filename) {
    return ast.mkInclude(filename, loc());
  },
      peg$c17 = function peg$c17(s, extra) {
    function kwarg(name, expr) {
      return ast.mkKwarg(ast.mkIdent(name, expr.loc), expr, expr.loc);
    }

    var size = null;
    var offset = null;

    if (extra !== null) {
      size = extra[1];
      offset = extra[3];
      return ast.mkBinary([kwarg('file', s), kwarg('size', size), kwarg('offset', offset)], loc());
    }

    return ast.mkBinary([kwarg('file', s)], loc());
  },
      peg$c18 = function peg$c18(kwargs) {
    return ast.mkBinary(kwargs, loc());
  },
      peg$c19 = function peg$c19(condition, trueBranch, elifs, elseBody) {
    var conds = [condition].concat(_toConsumableArray(elifs.map(function (e) {
      return e.condition;
    })));
    var trueBodies = [trueBranch].concat(_toConsumableArray(elifs.map(function (e) {
      return e.trueBranch;
    })));
    var cases = conds.map(function (c, i) {
      return [c, trueBodies[i]];
    });
    return ast.mkIfElse(cases, elseBody, loc());
  },
      peg$c20 = "in",
      peg$c21 = peg$literalExpectation("in", false),
      peg$c22 = function peg$c22(index, list, body) {
    return ast.mkFor(index, list, body, loc());
  },
      peg$c23 = function peg$c23(name, args, body) {
    return ast.mkMacro(name, args, body, loc());
  },
      peg$c24 = "+",
      peg$c25 = peg$literalExpectation("+", false),
      peg$c26 = function peg$c26(name, args) {
    return ast.mkCallMacro(name, args, loc());
  },
      peg$c27 = function peg$c27(name, value) {
    return ast.mkLet(name, value, loc());
  },
      peg$c28 = "as",
      peg$c29 = peg$literalExpectation("as", false),
      peg$c30 = function peg$c30(filename, plugin) {
    return ast.mkLoadPlugin(filename, plugin, loc());
  },
      peg$c31 = function peg$c31(error) {
    return ast.mkError(error, loc());
  },
      peg$c32 = function peg$c32(alignBytes) {
    return ast.mkAlign(alignBytes, loc());
  },
      peg$c33 = function peg$c33(name) {
    return ast.mkFilescope(name, loc());
  },
      peg$c34 = function peg$c34(name, args) {
    return ast.mkDeclareSegment(name, args, loc());
  },
      peg$c35 = function peg$c35(name) {
    return ast.mkUseSegment(name, loc());
  },
      peg$c36 = function peg$c36() {
    return ast.mkBreak(loc());
  },
      peg$c37 = function peg$c37(s) {
    return s;
  },
      peg$c38 = function peg$c38(condition, trueBranch) {
    return {
      condition: condition,
      trueBranch: trueBranch
    };
  },
      peg$c39 = function peg$c39(elseBody) {
    return elseBody;
  },
      peg$c40 = "\"",
      peg$c41 = peg$literalExpectation("\"", false),
      peg$c42 = function peg$c42(chars) {
    return ast.mkLiteral(chars.join(''), loc());
  },
      peg$c43 = peg$anyExpectation(),
      peg$c44 = function peg$c44(char) {
    return char;
  },
      peg$c45 = function peg$c45(name) {
    return ast.mkIdent(name, loc());
  },
      peg$c46 = function peg$c46(head, tail) {
    return buildList(head, tail, 1);
  },
      peg$c47 = function peg$c47(ident) {
    return ast.mkMacroArg(ident);
  },
      peg$c48 = function peg$c48(ident, value) {
    return ast.mkKwarg(ident, value, loc());
  },
      peg$c49 = function peg$c49(mnemonic, imm) {
    return mkinsn(mnemonic, imm, null, loc());
  },
      peg$c50 = "x",
      peg$c51 = peg$literalExpectation("x", false),
      peg$c52 = function peg$c52(mnemonic, abs) {
    // lda ($zp,x) indirect indexed
    return mkindx(mnemonic, abs, loc());
  },
      peg$c53 = "y",
      peg$c54 = peg$literalExpectation("y", false),
      peg$c55 = function peg$c55(mnemonic, abs) {
    // lda ($zp),y indirect indexed
    return mkindy(mnemonic, abs, loc());
  },
      peg$c56 = function peg$c56(mnemonic, abs) {
    // absolute indirect.  only possible form: jmp ($fffc)
    return mkabsind(mnemonic, abs, loc());
  },
      peg$c57 = function peg$c57(mnemonic, abs, r) {
    if (r === 'x') {
      return mkabsx(mnemonic, abs, loc());
    }

    return mkabsy(mnemonic, abs, loc());
  },
      peg$c58 = function peg$c58(mnemonic, abs) {
    return mkinsn(mnemonic, null, abs, loc());
  },
      peg$c59 = function peg$c59(mnemonic) {
    return mkinsn(mnemonic, null, null, loc());
  },
      peg$c60 = function peg$c60() {
    return text();
  },
      peg$c61 = function peg$c61(ident) {
    return ident;
  },
      peg$c62 = "::",
      peg$c63 = peg$literalExpectation("::", false),
      peg$c64 = function peg$c64(head, tail) {
    return ast.mkScopeQualifiedIdent(buildList(head, tail, 1), false, loc());
  },
      peg$c65 = function peg$c65(head, tail) {
    return ast.mkScopeQualifiedIdent(buildList(head, tail, 1), true, loc());
  },
      peg$c66 = function peg$c66(ident) {
    return ast.mkIdent(ident, loc());
  },
      peg$c67 = function peg$c67(sym) {
    return sym;
  },
      peg$c68 = "#",
      peg$c69 = peg$literalExpectation("#", false),
      peg$c70 = function peg$c70(lh, expr) {
    if (lh !== null) {
      if (lh === 'lo') {
        return ast.mkBinaryOp('&', expr, ast.mkLiteral(255, loc(), loc()));
      }

      var lit8 = ast.mkLiteral(8, loc());
      var lit255 = ast.mkLiteral(255, loc());
      return ast.mkBinaryOp('&', ast.mkBinaryOp('>>', expr, lit8, loc()), lit255, loc());
    }

    return expr;
  },
      peg$c71 = function peg$c71() {
    return 'lo';
  },
      peg$c72 = function peg$c72() {
    return 'hi';
  },
      peg$c73 = function peg$c73(expr) {
    return expr;
  },
      peg$c74 = function peg$c74(first, rest) {
    return rest.reduce(function (memo, curr) {
      return ast.mkBinaryOp(curr[0], memo, curr[1], loc());
    }, first);
  },
      peg$c75 = function peg$c75(op, expr) {
    return ast.mkUnary(op, expr, loc());
  },
      peg$c76 = function peg$c76(op) {
    return op;
  },
      peg$c77 = function peg$c77(head, property) {
    return {
      property: property,
      computed: true
    };
  },
      peg$c78 = function peg$c78(head, property) {
    return {
      property: ast.mkIdent(property, loc()),
      computed: false
    };
  },
      peg$c79 = function peg$c79(head, tail) {
    return tail.reduce(function (result, element) {
      return ast.mkMember(result, element.property, element.computed, loc());
    }, head);
  },
      peg$c80 = function peg$c80(callee, args) {
    return ast.mkCallFunc(callee, args, loc());
  },
      peg$c81 = function peg$c81(num) {
    return ast.mkLiteral(num, loc());
  },
      peg$c82 = function peg$c82(string) {
    return string;
  },
      peg$c83 = function peg$c83(e) {
    return e;
  },
      peg$c84 = "$",
      peg$c85 = peg$literalExpectation("$", false),
      peg$c86 = function peg$c86(hex) {
    return parseInt(hex, 16);
  },
      peg$c87 = "%",
      peg$c88 = peg$literalExpectation("%", false),
      peg$c89 = function peg$c89(binary) {
    return parseInt(binary, 2);
  },
      peg$c90 = function peg$c90(float) {
    return float;
  },
      peg$c91 = function peg$c91() {
    return ast.mkGetCurPC(loc());
  },
      peg$c92 = ".",
      peg$c93 = peg$literalExpectation(".", false),
      peg$c94 = function peg$c94() {
    return parseFloat(text());
  },
      peg$c95 = "0",
      peg$c96 = peg$literalExpectation("0", false),
      peg$c97 = /^[1-9]/,
      peg$c98 = peg$classExpectation([["1", "9"]], false, false),
      peg$c99 = "e",
      peg$c100 = peg$literalExpectation("e", true),
      peg$c101 = /^[+\-]/,
      peg$c102 = peg$classExpectation(["+", "-"], false, false),
      peg$c103 = function peg$c103(elts) {
    return ast.mkExprArray(elts === null ? [] : elts, loc());
  },
      peg$c104 = function peg$c104() {
    return ast.mkExprObject([], loc());
  },
      peg$c105 = function peg$c105(properties) {
    return ast.mkExprObject(properties, loc());
  },
      peg$c106 = function peg$c106(head, tail) {
    return buildList(head, tail, 2);
  },
      peg$c107 = function peg$c107(key, val) {
    return {
      key: key,
      val: val
    };
  },
      peg$c108 = function peg$c108(expr) {
    return ast.mkStmtExpr(expr, loc());
  },
      peg$c109 = function peg$c109(name, value) {
    return ast.mkAssign(name, value, loc());
  },
      peg$c110 = /^[a-zA-Z_]/,
      peg$c111 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false),
      peg$c112 = /^[a-zA-Z_0-9]/,
      peg$c113 = peg$classExpectation([["a", "z"], ["A", "Z"], "_", ["0", "9"]], false, false),
      peg$c114 = /^[0-9]/,
      peg$c115 = peg$classExpectation([["0", "9"]], false, false),
      peg$c116 = /^[0-1]/,
      peg$c117 = peg$classExpectation([["0", "1"]], false, false),
      peg$c118 = /^[0-9a-f]/i,
      peg$c119 = peg$classExpectation([["0", "9"], ["a", "f"]], false, true),
      peg$c120 = peg$otherExpectation("whitespace"),
      peg$c121 = "\t",
      peg$c122 = peg$literalExpectation("\t", false),
      peg$c123 = "\x0B",
      peg$c124 = peg$literalExpectation("\x0B", false),
      peg$c125 = "\f",
      peg$c126 = peg$literalExpectation("\f", false),
      peg$c127 = " ",
      peg$c128 = peg$literalExpectation(" ", false),
      peg$c129 = "\xA0",
      peg$c130 = peg$literalExpectation("\xA0", false),
      peg$c131 = "\uFEFF",
      peg$c132 = peg$literalExpectation("\uFEFF", false),
      peg$c133 = /^[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
      peg$c134 = peg$classExpectation([" ", "\xA0", "\u1680", ["\u2000", "\u200A"], "\u202F", "\u205F", "\u3000"], false, false),
      peg$c135 = ";",
      peg$c136 = peg$literalExpectation(";", false),
      peg$c137 = /^[\n\r]/,
      peg$c138 = peg$classExpectation(["\n", "\r"], false, false),
      peg$c139 = peg$otherExpectation("end of line"),
      peg$c140 = "\n",
      peg$c141 = peg$literalExpectation("\n", false),
      peg$c142 = "\r\n",
      peg$c143 = peg$literalExpectation("\r\n", false),
      peg$c144 = "\r",
      peg$c145 = peg$literalExpectation("\r", false),
      peg$c146 = "!align",
      peg$c147 = peg$literalExpectation("!align", false),
      peg$c148 = "!byte",
      peg$c149 = peg$literalExpectation("!byte", false),
      peg$c150 = function peg$c150() {
    return 'byte';
  },
      peg$c151 = "!word",
      peg$c152 = peg$literalExpectation("!word", false),
      peg$c153 = function peg$c153() {
    return 'word';
  },
      peg$c154 = "!binary",
      peg$c155 = peg$literalExpectation("!binary", false),
      peg$c156 = "!let",
      peg$c157 = peg$literalExpectation("!let", false),
      peg$c158 = "!macro",
      peg$c159 = peg$literalExpectation("!macro", false),
      peg$c160 = "!if",
      peg$c161 = peg$literalExpectation("!if", false),
      peg$c162 = "else",
      peg$c163 = peg$literalExpectation("else", false),
      peg$c164 = "elif",
      peg$c165 = peg$literalExpectation("elif", false),
      peg$c166 = "!error",
      peg$c167 = peg$literalExpectation("!error", false),
      peg$c168 = "!for",
      peg$c169 = peg$literalExpectation("!for", false),
      peg$c170 = "!include",
      peg$c171 = peg$literalExpectation("!include", false),
      peg$c172 = "!fill",
      peg$c173 = peg$literalExpectation("!fill", false),
      peg$c174 = "!use",
      peg$c175 = peg$literalExpectation("!use", false),
      peg$c176 = "!filescope",
      peg$c177 = peg$literalExpectation("!filescope", false),
      peg$c178 = "!segment",
      peg$c179 = peg$literalExpectation("!segment", false),
      peg$c180 = "!break",
      peg$c181 = peg$literalExpectation("!break", false),
      peg$c182 = "!!",
      peg$c183 = peg$literalExpectation("!!", false),
      peg$c184 = "[",
      peg$c185 = peg$literalExpectation("[", false),
      peg$c186 = function peg$c186(s) {
    return s;
  },
      peg$c187 = "]",
      peg$c188 = peg$literalExpectation("]", false),
      peg$c189 = "(",
      peg$c190 = peg$literalExpectation("(", false),
      peg$c191 = ")",
      peg$c192 = peg$literalExpectation(")", false),
      peg$c193 = "{",
      peg$c194 = peg$literalExpectation("{", false),
      peg$c195 = "}",
      peg$c196 = peg$literalExpectation("}", false),
      peg$c197 = "->",
      peg$c198 = peg$literalExpectation("->", false),
      peg$c199 = "++",
      peg$c200 = peg$literalExpectation("++", false),
      peg$c201 = "--",
      peg$c202 = peg$literalExpectation("--", false),
      peg$c203 = "&",
      peg$c204 = peg$literalExpectation("&", false),
      peg$c205 = /^[&]/,
      peg$c206 = peg$classExpectation(["&"], false, false),
      peg$c207 = "*",
      peg$c208 = peg$literalExpectation("*", false),
      peg$c209 = /^[=]/,
      peg$c210 = peg$classExpectation(["="], false, false),
      peg$c211 = /^[+=]/,
      peg$c212 = peg$classExpectation(["+", "="], false, false),
      peg$c213 = "-",
      peg$c214 = peg$literalExpectation("-", false),
      peg$c215 = /^[\-=>]/,
      peg$c216 = peg$classExpectation(["-", "=", ">"], false, false),
      peg$c217 = "~",
      peg$c218 = peg$literalExpectation("~", false),
      peg$c219 = "!",
      peg$c220 = peg$literalExpectation("!", false),
      peg$c221 = "/",
      peg$c222 = peg$literalExpectation("/", false),
      peg$c223 = /^[=>]/,
      peg$c224 = peg$classExpectation(["=", ">"], false, false),
      peg$c225 = "<<",
      peg$c226 = peg$literalExpectation("<<", false),
      peg$c227 = ">>",
      peg$c228 = peg$literalExpectation(">>", false),
      peg$c229 = "<",
      peg$c230 = peg$literalExpectation("<", false),
      peg$c231 = ">",
      peg$c232 = peg$literalExpectation(">", false),
      peg$c233 = "<=",
      peg$c234 = peg$literalExpectation("<=", false),
      peg$c235 = ">=",
      peg$c236 = peg$literalExpectation(">=", false),
      peg$c237 = "==",
      peg$c238 = peg$literalExpectation("==", false),
      peg$c239 = "!=",
      peg$c240 = peg$literalExpectation("!=", false),
      peg$c241 = "^",
      peg$c242 = peg$literalExpectation("^", false),
      peg$c243 = "|",
      peg$c244 = peg$literalExpectation("|", false),
      peg$c245 = "&&",
      peg$c246 = peg$literalExpectation("&&", false),
      peg$c247 = "||",
      peg$c248 = peg$literalExpectation("||", false),
      peg$c249 = "?",
      peg$c250 = peg$literalExpectation("?", false),
      peg$c251 = /^[>]/,
      peg$c252 = peg$classExpectation([">"], false, false),
      peg$c253 = "...",
      peg$c254 = peg$literalExpectation("...", false),
      peg$c255 = "=",
      peg$c256 = peg$literalExpectation("=", false),
      peg$c257 = "*=",
      peg$c258 = peg$literalExpectation("*=", false),
      peg$c259 = "/=",
      peg$c260 = peg$literalExpectation("/=", false),
      peg$c261 = "%=",
      peg$c262 = peg$literalExpectation("%=", false),
      peg$c263 = "+=",
      peg$c264 = peg$literalExpectation("+=", false),
      peg$c265 = "-=",
      peg$c266 = peg$literalExpectation("-=", false),
      peg$c267 = "<<=",
      peg$c268 = peg$literalExpectation("<<=", false),
      peg$c269 = ">>=",
      peg$c270 = peg$literalExpectation(">>=", false),
      peg$c271 = "&=",
      peg$c272 = peg$literalExpectation("&=", false),
      peg$c273 = "^=",
      peg$c274 = peg$literalExpectation("^=", false),
      peg$c275 = "|=",
      peg$c276 = peg$literalExpectation("|=", false),
      peg$c277 = ",",
      peg$c278 = peg$literalExpectation(",", false),
      peg$currPos = 0,
      peg$savedPos = 0,
      peg$posDetailsCache = [{
    line: 1,
    column: 1
  }],
      peg$maxFailPos = 0,
      peg$maxFailExpected = [],
      peg$silentFails = 0,
      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return {
      type: "literal",
      text: text,
      ignoreCase: ignoreCase
    };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return {
      type: "class",
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    };
  }

  function peg$anyExpectation() {
    return {
      type: "any"
    };
  }

  function peg$endExpectation() {
    return {
      type: "end"
    };
  }

  function peg$otherExpectation(description) {
    return {
      type: "other",
      description: description
    };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos],
        p;

    if (details) {
      return details;
    } else {
      p = pos - 1;

      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails = peg$computePosDetails(endPos);
    return {
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
  }

  function peg$parsestatements() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseinsnLineWithComment();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseLineTerminator();

      if (s4 !== peg$FAILED) {
        s5 = peg$parseinsnLineWithComment();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseLineTerminator();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseinsnLineWithComment();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseinsnLineWithComment() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parsews();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseinsnLine();

      if (s2 !== peg$FAILED) {
        s3 = peg$parselineComment();

        if (s3 === peg$FAILED) {
          s3 = null;
        }

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c1(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseinsnLine() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$parselabel();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseLWING();

      if (s2 !== peg$FAILED) {
        s3 = peg$parsestatements();

        if (s3 !== peg$FAILED) {
          s4 = peg$parseRWING();

          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c2(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parselabel();

      if (s1 !== peg$FAILED) {
        s2 = peg$parsestatement();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c3(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parselabel();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c4(s1);
        }

        s0 = s1;

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsestatement();

          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c5(s1);
          }

          s0 = s1;

          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsesetPC();

            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c6(s1);
            }

            s0 = s1;

            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parsews();

              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c7();
              }

              s0 = s1;
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parsestatement() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parsedirective();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c8(s1);
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseinstruction();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c9(s1);
      }

      s0 = s1;
    }

    return s0;
  }

  function peg$parselabel() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parseidentNoWS();

    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 58) {
        s2 = peg$c10;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c11);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c12(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsesetPC() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parseSTAR();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseEQU();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseboolOrExpr();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c13(s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsedirective() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    s0 = peg$currPos;
    s1 = peg$parsePSEUDO_BYTE();

    if (s1 === peg$FAILED) {
      s1 = peg$parsePSEUDO_WORD();
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseexprList();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c14(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsePSEUDO_FILL();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseboolOrExpr();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseCOMMA();

          if (s3 !== peg$FAILED) {
            s4 = peg$parseboolOrExpr();

            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c15(s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsePSEUDO_INCLUDE();

        if (s1 !== peg$FAILED) {
          s2 = peg$parseboolOrExpr();

          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c16(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsePSEUDO_BINARY();

          if (s1 !== peg$FAILED) {
            s2 = peg$parseboolOrExpr();

            if (s2 !== peg$FAILED) {
              s3 = peg$currPos;
              s4 = peg$parseCOMMA();

              if (s4 !== peg$FAILED) {
                s5 = peg$parseboolOrExpr();

                if (s5 === peg$FAILED) {
                  s5 = null;
                }

                if (s5 !== peg$FAILED) {
                  s6 = peg$parseCOMMA();

                  if (s6 !== peg$FAILED) {
                    s7 = peg$parseboolOrExpr();

                    if (s7 !== peg$FAILED) {
                      s4 = [s4, s5, s6, s7];
                      s3 = s4;
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }

              if (s3 === peg$FAILED) {
                s3 = null;
              }

              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c17(s2, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }

          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsePSEUDO_BINARY();

            if (s1 !== peg$FAILED) {
              s2 = peg$parseLPAR();

              if (s2 !== peg$FAILED) {
                s3 = peg$parsekwargsList();

                if (s3 !== peg$FAILED) {
                  s4 = peg$parseRPAR();

                  if (s4 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c18(s3);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }

            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parsePSEUDO_IF();

              if (s1 !== peg$FAILED) {
                s2 = peg$parseLPAR();

                if (s2 !== peg$FAILED) {
                  s3 = peg$parseboolOrExpr();

                  if (s3 !== peg$FAILED) {
                    s4 = peg$parseRPAR();

                    if (s4 !== peg$FAILED) {
                      s5 = peg$parseLWING();

                      if (s5 !== peg$FAILED) {
                        s6 = peg$parsestatements();

                        if (s6 !== peg$FAILED) {
                          s7 = peg$parseRWING();

                          if (s7 !== peg$FAILED) {
                            s8 = [];
                            s9 = peg$parseelif();

                            while (s9 !== peg$FAILED) {
                              s8.push(s9);
                              s9 = peg$parseelif();
                            }

                            if (s8 !== peg$FAILED) {
                              s9 = peg$parseelseBody();

                              if (s9 === peg$FAILED) {
                                s9 = null;
                              }

                              if (s9 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c19(s3, s6, s8, s9);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }

              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsePSEUDO_FOR();

                if (s1 !== peg$FAILED) {
                  s2 = peg$parseidentifier();

                  if (s2 !== peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c20) {
                      s3 = peg$c20;
                      peg$currPos += 2;
                    } else {
                      s3 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c21);
                      }
                    }

                    if (s3 !== peg$FAILED) {
                      s4 = peg$parsews();

                      if (s4 !== peg$FAILED) {
                        s5 = peg$parseboolOrExpr();

                        if (s5 !== peg$FAILED) {
                          s6 = peg$parseLWING();

                          if (s6 !== peg$FAILED) {
                            s7 = peg$parsestatements();

                            if (s7 !== peg$FAILED) {
                              s8 = peg$parseRWING();

                              if (s8 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c22(s2, s5, s7);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }

                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$parsePSEUDO_MACRO();

                  if (s1 !== peg$FAILED) {
                    s2 = peg$parsemacroName();

                    if (s2 !== peg$FAILED) {
                      s3 = peg$parseLPAR();

                      if (s3 !== peg$FAILED) {
                        s4 = peg$parsemacroArgNameList();

                        if (s4 === peg$FAILED) {
                          s4 = null;
                        }

                        if (s4 !== peg$FAILED) {
                          s5 = peg$parseRPAR();

                          if (s5 !== peg$FAILED) {
                            s6 = peg$parseLWING();

                            if (s6 !== peg$FAILED) {
                              s7 = peg$parsestatements();

                              if (s7 !== peg$FAILED) {
                                s8 = peg$parseRWING();

                                if (s8 !== peg$FAILED) {
                                  peg$savedPos = s0;
                                  s1 = peg$c23(s2, s4, s7);
                                  s0 = s1;
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }

                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;

                    if (input.charCodeAt(peg$currPos) === 43) {
                      s1 = peg$c24;
                      peg$currPos++;
                    } else {
                      s1 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c25);
                      }
                    }

                    if (s1 !== peg$FAILED) {
                      s2 = peg$parsescopeQualifiedIdentifier();

                      if (s2 !== peg$FAILED) {
                        s3 = peg$parseLPAR();

                        if (s3 !== peg$FAILED) {
                          s4 = peg$parseexprList();

                          if (s4 === peg$FAILED) {
                            s4 = null;
                          }

                          if (s4 !== peg$FAILED) {
                            s5 = peg$parseRPAR();

                            if (s5 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c26(s2, s4);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }

                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      s1 = peg$parsePSEUDO_LET();

                      if (s1 !== peg$FAILED) {
                        s2 = peg$parseidentifier();

                        if (s2 !== peg$FAILED) {
                          s3 = peg$parseEQU();

                          if (s3 !== peg$FAILED) {
                            s4 = peg$parseboolOrExpr();

                            if (s4 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c27(s2, s4);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }

                      if (s0 === peg$FAILED) {
                        s0 = peg$parsestatementAssign();

                        if (s0 === peg$FAILED) {
                          s0 = peg$currPos;
                          s1 = peg$parsePSEUDO_USE();

                          if (s1 !== peg$FAILED) {
                            s2 = peg$parsestring();

                            if (s2 !== peg$FAILED) {
                              if (input.substr(peg$currPos, 2) === peg$c28) {
                                s3 = peg$c28;
                                peg$currPos += 2;
                              } else {
                                s3 = peg$FAILED;

                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c29);
                                }
                              }

                              if (s3 !== peg$FAILED) {
                                s4 = peg$parsews();

                                if (s4 !== peg$FAILED) {
                                  s5 = peg$parseidentifier();

                                  if (s5 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c30(s2, s5);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }

                          if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parsePSEUDO_ERROR();

                            if (s1 !== peg$FAILED) {
                              s2 = peg$parsestring();

                              if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c31(s2);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }

                            if (s0 === peg$FAILED) {
                              s0 = peg$currPos;
                              s1 = peg$parsePSEUDO_ALIGN();

                              if (s1 !== peg$FAILED) {
                                s2 = peg$parseboolOrExpr();

                                if (s2 !== peg$FAILED) {
                                  peg$savedPos = s0;
                                  s1 = peg$c32(s2);
                                  s0 = s1;
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }

                              if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                s1 = peg$parsePSEUDO_FILESCOPE();

                                if (s1 !== peg$FAILED) {
                                  s2 = peg$parseidentifier();

                                  if (s2 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c33(s2);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }

                                if (s0 === peg$FAILED) {
                                  s0 = peg$currPos;
                                  s1 = peg$parsePSEUDO_SEGMENT();

                                  if (s1 !== peg$FAILED) {
                                    s2 = peg$parseidentifier();

                                    if (s2 !== peg$FAILED) {
                                      s3 = peg$parseLPAR();

                                      if (s3 !== peg$FAILED) {
                                        s4 = peg$parsekwargsList();

                                        if (s4 !== peg$FAILED) {
                                          s5 = peg$parseRPAR();

                                          if (s5 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c34(s2, s4);
                                            s0 = s1;
                                          } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                          }
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }

                                  if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    s1 = peg$parsePSEUDO_SEGMENT();

                                    if (s1 !== peg$FAILED) {
                                      s2 = peg$parsescopeQualifiedIdentifier();

                                      if (s2 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c35(s2);
                                        s0 = s1;
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }

                                    if (s0 === peg$FAILED) {
                                      s0 = peg$currPos;
                                      s1 = peg$parsePSEUDO_BREAK();

                                      if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c36();
                                      }

                                      s0 = s1;

                                      if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        s1 = peg$parsePSEUDO_STATEMENT();

                                        if (s1 !== peg$FAILED) {
                                          s2 = peg$parseexecStatement();

                                          if (s2 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c37(s2);
                                            s0 = s1;
                                          } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                          }
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseelif() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parsePSEUDO_ELIF();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseLPAR();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseboolOrExpr();

        if (s3 !== peg$FAILED) {
          s4 = peg$parseRPAR();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseLWING();

            if (s5 !== peg$FAILED) {
              s6 = peg$parsestatements();

              if (s6 !== peg$FAILED) {
                s7 = peg$parseRWING();

                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c38(s3, s6);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseelseBody() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$parsePSEUDO_ELSE();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseLWING();

      if (s2 !== peg$FAILED) {
        s3 = peg$parsestatements();

        if (s3 !== peg$FAILED) {
          s4 = peg$parseRWING();

          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c39(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsestring() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c40;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c41);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parsedoubleStringCharacter();

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parsedoubleStringCharacter();
      }

      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 34) {
          s3 = peg$c40;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c41);
          }
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$parsews();

          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c42(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsedoubleStringCharacter() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 34) {
      s2 = peg$c40;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c41);
      }
    }

    peg$silentFails--;

    if (s2 === peg$FAILED) {
      s1 = void 0;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      if (input.length > peg$currPos) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c43);
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c44(s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsemacroName() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parseident();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c45(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsemacroArgNameList() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsemacroArgName();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseCOMMA();

      if (s4 !== peg$FAILED) {
        s5 = peg$parsemacroArgName();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseCOMMA();

        if (s4 !== peg$FAILED) {
          s5 = peg$parsemacroArgName();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c46(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsemacroArgName() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parseidentifier();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c47(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsekwargsList() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsekwarg();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseCOMMA();

      if (s4 !== peg$FAILED) {
        s5 = peg$parsekwarg();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseCOMMA();

        if (s4 !== peg$FAILED) {
          s5 = peg$parsekwarg();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c46(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsekwarg() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parseidentifier();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseEQU();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseboolOrExpr();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c48(s1, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseexprList() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseboolOrExpr();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseCOMMA();

      if (s4 !== peg$FAILED) {
        s5 = peg$parseboolOrExpr();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseCOMMA();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseboolOrExpr();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c46(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseinstruction() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parsemnemonic();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseimm();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c49(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsemnemonic();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseLPAR();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseabs();

          if (s3 !== peg$FAILED) {
            s4 = peg$parseCOMMA();

            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 120) {
                s5 = peg$c50;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c51);
                }
              }

              if (s5 !== peg$FAILED) {
                s6 = peg$parsews();

                if (s6 !== peg$FAILED) {
                  s7 = peg$parseRPAR();

                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c52(s1, s3);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsemnemonic();

        if (s1 !== peg$FAILED) {
          s2 = peg$parseLPAR();

          if (s2 !== peg$FAILED) {
            s3 = peg$parseabs();

            if (s3 !== peg$FAILED) {
              s4 = peg$parseRPAR();

              if (s4 !== peg$FAILED) {
                s5 = peg$parseCOMMA();

                if (s5 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 121) {
                    s6 = peg$c53;
                    peg$currPos++;
                  } else {
                    s6 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c54);
                    }
                  }

                  if (s6 !== peg$FAILED) {
                    s7 = peg$parsews();

                    if (s7 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c55(s1, s3);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsemnemonic();

          if (s1 !== peg$FAILED) {
            s2 = peg$parseLPAR();

            if (s2 !== peg$FAILED) {
              s3 = peg$parseabs();

              if (s3 !== peg$FAILED) {
                s4 = peg$parseRPAR();

                if (s4 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c56(s1, s3);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }

          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsemnemonic();

            if (s1 !== peg$FAILED) {
              s2 = peg$parseabs();

              if (s2 !== peg$FAILED) {
                s3 = peg$parseCOMMA();

                if (s3 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 120) {
                    s4 = peg$c50;
                    peg$currPos++;
                  } else {
                    s4 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c51);
                    }
                  }

                  if (s4 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 121) {
                      s4 = peg$c53;
                      peg$currPos++;
                    } else {
                      s4 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c54);
                      }
                    }
                  }

                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsews();

                    if (s5 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c57(s1, s2, s4);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }

            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parsemnemonic();

              if (s1 !== peg$FAILED) {
                s2 = peg$parseabs();

                if (s2 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c58(s1, s2);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }

              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsemnemonic();

                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c59(s1);
                }

                s0 = s1;
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseidentNoWS() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = [];
    s3 = peg$parsealpha();

    if (s3 !== peg$FAILED) {
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parsealpha();
      }
    } else {
      s2 = peg$FAILED;
    }

    if (s2 !== peg$FAILED) {
      s3 = [];
      s4 = peg$parsealphanum();

      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$parsealphanum();
      }

      if (s3 !== peg$FAILED) {
        s2 = [s2, s3];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c60();
    }

    s0 = s1;
    return s0;
  }

  function peg$parselabelIdent() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = peg$parseidentNoWS();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c61(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsescopeQualifiedIdentifier() {
    var s0, s1, s2, s3, s4, s5, s6;
    s0 = peg$currPos;
    s1 = peg$parseidentNoWS();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c62) {
        s4 = peg$c62;
        peg$currPos += 2;
      } else {
        s4 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c63);
        }
      }

      if (s4 !== peg$FAILED) {
        s5 = peg$parseidentNoWS();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;

        if (input.substr(peg$currPos, 2) === peg$c62) {
          s4 = peg$c62;
          peg$currPos += 2;
        } else {
          s4 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c63);
          }
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parseidentNoWS();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c64(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c62) {
        s1 = peg$c62;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c63);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseidentNoWS();

        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$currPos;

          if (input.substr(peg$currPos, 2) === peg$c62) {
            s5 = peg$c62;
            peg$currPos += 2;
          } else {
            s5 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c63);
            }
          }

          if (s5 !== peg$FAILED) {
            s6 = peg$parseidentNoWS();

            if (s6 !== peg$FAILED) {
              s5 = [s5, s6];
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }

          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;

            if (input.substr(peg$currPos, 2) === peg$c62) {
              s5 = peg$c62;
              peg$currPos += 2;
            } else {
              s5 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c63);
              }
            }

            if (s5 !== peg$FAILED) {
              s6 = peg$parseidentNoWS();

              if (s6 !== peg$FAILED) {
                s5 = [s5, s6];
                s4 = s5;
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }

          if (s3 !== peg$FAILED) {
            s4 = peg$parsews();

            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c65(s2, s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseidentifier() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parseident();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c66(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parseident() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = peg$parseidentNoWS();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c67(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsemnemonic() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = peg$parseidentNoWS();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c61(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseimm() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 35) {
      s1 = peg$c68;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c69);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseloOrHi();

      if (s2 === peg$FAILED) {
        s2 = null;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parseboolOrExpr();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c70(s2, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseloOrHi() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parseLT();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c71();
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseGT();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c72();
      }

      s0 = s1;
    }

    return s0;
  }

  function peg$parseabs() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parseboolOrExpr();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c73(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsemultiplicative() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseunaryExpression();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseSTAR();

      if (s4 === peg$FAILED) {
        s4 = peg$parseDIV();

        if (s4 === peg$FAILED) {
          s4 = peg$parseMOD();
        }
      }

      if (s4 !== peg$FAILED) {
        s5 = peg$parseunaryExpression();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseSTAR();

        if (s4 === peg$FAILED) {
          s4 = peg$parseDIV();

          if (s4 === peg$FAILED) {
            s4 = peg$parseMOD();
          }
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parseunaryExpression();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$parseprimary();
    }

    return s0;
  }

  function peg$parseadditive() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsemultiplicative();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parsePLUS();

      if (s4 === peg$FAILED) {
        s4 = peg$parseMINUS();
      }

      if (s4 !== peg$FAILED) {
        s5 = peg$parsemultiplicative();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parsePLUS();

        if (s4 === peg$FAILED) {
          s4 = peg$parseMINUS();
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parsemultiplicative();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseshift() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseadditive();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseLEFT();

      if (s4 === peg$FAILED) {
        s4 = peg$parseRIGHT();
      }

      if (s4 !== peg$FAILED) {
        s5 = peg$parseadditive();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseLEFT();

        if (s4 === peg$FAILED) {
          s4 = peg$parseRIGHT();
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parseadditive();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parserelational() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseshift();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseLE();

      if (s4 === peg$FAILED) {
        s4 = peg$parseGE();

        if (s4 === peg$FAILED) {
          s4 = peg$parseLT();

          if (s4 === peg$FAILED) {
            s4 = peg$parseGT();
          }
        }
      }

      if (s4 !== peg$FAILED) {
        s5 = peg$parseshift();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseLE();

        if (s4 === peg$FAILED) {
          s4 = peg$parseGE();

          if (s4 === peg$FAILED) {
            s4 = peg$parseLT();

            if (s4 === peg$FAILED) {
              s4 = peg$parseGT();
            }
          }
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parseshift();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseequality() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parserelational();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseEQUEQU();

      if (s4 === peg$FAILED) {
        s4 = peg$parseBANGEQU();
      }

      if (s4 !== peg$FAILED) {
        s5 = peg$parserelational();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseEQUEQU();

        if (s4 === peg$FAILED) {
          s4 = peg$parseBANGEQU();
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parserelational();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseandExpr() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseequality();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseAND();

      if (s4 !== peg$FAILED) {
        s5 = peg$parseequality();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseAND();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseequality();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsexorExpr() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseandExpr();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseHAT();

      if (s4 !== peg$FAILED) {
        s5 = peg$parseandExpr();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseHAT();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseandExpr();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseorExpr() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsexorExpr();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseOR();

      if (s4 !== peg$FAILED) {
        s5 = peg$parsexorExpr();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseOR();

        if (s4 !== peg$FAILED) {
          s5 = peg$parsexorExpr();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseboolAndExpr() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseorExpr();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseANDAND();

      if (s4 !== peg$FAILED) {
        s5 = peg$parseorExpr();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseANDAND();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseorExpr();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseboolOrExpr() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseboolAndExpr();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseOROR();

      if (s4 !== peg$FAILED) {
        s5 = peg$parseboolAndExpr();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseOROR();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseboolAndExpr();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c74(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseunaryExpression() {
    var s0, s1, s2;
    s0 = peg$parsecallOrMemberExpression();

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseunaryOperator();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseunaryExpression();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c75(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseunaryOperator() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parsePLUS();

    if (s1 === peg$FAILED) {
      s1 = peg$parseMINUS();

      if (s1 === peg$FAILED) {
        s1 = peg$parseTILDA();

        if (s1 === peg$FAILED) {
          s1 = peg$parseBANG();
        }
      }
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c76(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsecallOrMemberExpression() {
    var s0;
    s0 = peg$parsecallExpression();

    if (s0 === peg$FAILED) {
      s0 = peg$parsememberExpression();
    }

    return s0;
  }

  function peg$parsememberExpression() {
    var s0, s1, s2, s3, s4, s5, s6;
    s0 = peg$currPos;
    s1 = peg$parseprimary();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseLBRK();

      if (s4 !== peg$FAILED) {
        s5 = peg$parseboolOrExpr();

        if (s5 !== peg$FAILED) {
          s6 = peg$parseRBRK();

          if (s6 !== peg$FAILED) {
            peg$savedPos = s3;
            s4 = peg$c77(s1, s5);
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      if (s3 === peg$FAILED) {
        s3 = peg$currPos;
        s4 = peg$parseDOT();

        if (s4 !== peg$FAILED) {
          s5 = peg$parselabelIdent();

          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s4 = peg$c78(s1, s5);
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseLBRK();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseboolOrExpr();

          if (s5 !== peg$FAILED) {
            s6 = peg$parseRBRK();

            if (s6 !== peg$FAILED) {
              peg$savedPos = s3;
              s4 = peg$c77(s1, s5);
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        if (s3 === peg$FAILED) {
          s3 = peg$currPos;
          s4 = peg$parseDOT();

          if (s4 !== peg$FAILED) {
            s5 = peg$parselabelIdent();

            if (s5 !== peg$FAILED) {
              peg$savedPos = s3;
              s4 = peg$c78(s1, s5);
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c79(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsecallExpression() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$parsememberExpression();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseLPAR();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseexprList();

        if (s3 === peg$FAILED) {
          s3 = null;
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$parseRPAR();

          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c80(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseprimary() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parsenum();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c81(s1);
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsescopeQualifiedIdentifier();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c61(s1);
      }

      s0 = s1;

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsestring();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c82(s1);
        }

        s0 = s1;

        if (s0 === peg$FAILED) {
          s0 = peg$parsearrayLiteral();

          if (s0 === peg$FAILED) {
            s0 = peg$parseobjectLiteral();

            if (s0 === peg$FAILED) {
              s0 = peg$parsecurPC();

              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseLPAR();

                if (s1 !== peg$FAILED) {
                  s2 = peg$parseboolOrExpr();

                  if (s2 !== peg$FAILED) {
                    s3 = peg$parseRPAR();

                    if (s3 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c83(s2);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parsenum() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 36) {
      s1 = peg$c84;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c85);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = [];
      s4 = peg$parsehexdig();

      if (s4 !== peg$FAILED) {
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parsehexdig();
        }
      } else {
        s3 = peg$FAILED;
      }

      if (s3 !== peg$FAILED) {
        s2 = input.substring(s2, peg$currPos);
      } else {
        s2 = s3;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c86(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 37) {
        s1 = peg$c87;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c88);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = [];
        s4 = peg$parsezeroone();

        if (s4 !== peg$FAILED) {
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$parsezeroone();
          }
        } else {
          s3 = peg$FAILED;
        }

        if (s3 !== peg$FAILED) {
          s2 = input.substring(s2, peg$currPos);
        } else {
          s2 = s3;
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$parsews();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c89(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseDecimalLiteral();

        if (s1 !== peg$FAILED) {
          s2 = peg$parsews();

          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c90(s1);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parsecurPC() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parseSTAR();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c91();
    }

    s0 = s1;
    return s0;
  }

  function peg$parseDecimalLiteral() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$parseDecimalIntegerLiteral();

    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 46) {
        s2 = peg$c92;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c93);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parsedigit();

        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parsedigit();
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$parseExponentPart();

          if (s4 === peg$FAILED) {
            s4 = null;
          }

          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c94();
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 46) {
        s1 = peg$c92;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c93);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parsedigit();

        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parsedigit();
          }
        } else {
          s2 = peg$FAILED;
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$parseExponentPart();

          if (s3 === peg$FAILED) {
            s3 = null;
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c94();
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseDecimalIntegerLiteral();

        if (s1 !== peg$FAILED) {
          s2 = peg$parseExponentPart();

          if (s2 === peg$FAILED) {
            s2 = null;
          }

          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c94();
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parseDecimalIntegerLiteral() {
    var s0, s1, s2, s3;

    if (input.charCodeAt(peg$currPos) === 48) {
      s0 = peg$c95;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c96);
      }
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseNonZeroDigit();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parsedigit();

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parsedigit();
        }

        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseNonZeroDigit() {
    var s0;

    if (peg$c97.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c98);
      }
    }

    return s0;
  }

  function peg$parseExponentPart() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = peg$parseExponentIndicator();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseSignedInteger();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseExponentIndicator() {
    var s0;

    if (input.substr(peg$currPos, 1).toLowerCase() === peg$c99) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c100);
      }
    }

    return s0;
  }

  function peg$parseSignedInteger() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (peg$c101.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c102);
      }
    }

    if (s1 === peg$FAILED) {
      s1 = null;
    }

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parsedigit();

      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parsedigit();
        }
      } else {
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsearrayLiteral() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parseLBRK();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseexprList();

      if (s2 === peg$FAILED) {
        s2 = null;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parseRBRK();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c103(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseobjectLiteral() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parseLWING();

    if (s1 !== peg$FAILED) {
      s2 = peg$parse_n_();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseRWING();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c104();
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseLWING();

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_n_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parsePropertyNameAndValueList();

          if (s3 !== peg$FAILED) {
            s4 = peg$parse_n_();

            if (s4 !== peg$FAILED) {
              s5 = peg$parseRWING();

              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c105(s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseLWING();

        if (s1 !== peg$FAILED) {
          s2 = peg$parse_n_();

          if (s2 !== peg$FAILED) {
            s3 = peg$parsePropertyNameAndValueList();

            if (s3 !== peg$FAILED) {
              s4 = peg$parse_n_();

              if (s4 !== peg$FAILED) {
                s5 = peg$parseCOMMA();

                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_n_();

                  if (s6 !== peg$FAILED) {
                    s7 = peg$parseRWING();

                    if (s7 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c105(s3);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parsePropertyNameAndValueList() {
    var s0, s1, s2, s3, s4, s5, s6;
    s0 = peg$currPos;
    s1 = peg$parsePropertyAssignment();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseCOMMA();

      if (s4 !== peg$FAILED) {
        s5 = peg$parse_n_();

        if (s5 !== peg$FAILED) {
          s6 = peg$parsePropertyAssignment();

          if (s6 !== peg$FAILED) {
            s4 = [s4, s5, s6];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseCOMMA();

        if (s4 !== peg$FAILED) {
          s5 = peg$parse_n_();

          if (s5 !== peg$FAILED) {
            s6 = peg$parsePropertyAssignment();

            if (s6 !== peg$FAILED) {
              s4 = [s4, s5, s6];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c106(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePropertyAssignment() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parsePropertyName();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseCOLON();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseboolOrExpr();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c107(s1, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePropertyName() {
    var s0, s1;
    s0 = peg$parseidentifier();

    if (s0 === peg$FAILED) {
      s0 = peg$parsestring();

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsenum();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c81(s1);
        }

        s0 = s1;
      }
    }

    return s0;
  }

  function peg$parseexecStatement() {
    var s0, s1;
    s0 = peg$parsestatementAssign();

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseboolOrExpr();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c108(s1);
      }

      s0 = s1;
    }

    return s0;
  }

  function peg$parsestatementAssign() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parsescopeQualifiedIdentifier();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseEQU();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseboolOrExpr();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c109(s1, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsealpha() {
    var s0;

    if (peg$c110.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c111);
      }
    }

    return s0;
  }

  function peg$parsealphanum() {
    var s0;

    if (peg$c112.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c113);
      }
    }

    return s0;
  }

  function peg$parsedigit() {
    var s0;

    if (peg$c114.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c115);
      }
    }

    return s0;
  }

  function peg$parsezeroone() {
    var s0;

    if (peg$c116.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c117);
      }
    }

    return s0;
  }

  function peg$parsehexdig() {
    var s0;

    if (peg$c118.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c119);
      }
    }

    return s0;
  }

  function peg$parsews() {
    var s0, s1;
    peg$silentFails++;
    s0 = [];
    s1 = peg$parseWhiteSpace();

    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parseWhiteSpace();
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c120);
      }
    }

    return s0;
  }

  function peg$parseWhiteSpace() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 9) {
      s0 = peg$c121;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c122);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 11) {
        s0 = peg$c123;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c124);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 12) {
          s0 = peg$c125;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c126);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 32) {
            s0 = peg$c127;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c128);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 160) {
              s0 = peg$c129;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c130);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 65279) {
                s0 = peg$c131;
                peg$currPos++;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c132);
                }
              }

              if (s0 === peg$FAILED) {
                s0 = peg$parseZs();
              }
            }
          }
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c120);
      }
    }

    return s0;
  }

  function peg$parseZs() {
    var s0;

    if (peg$c133.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c134);
      }
    }

    return s0;
  }

  function peg$parse_n_() {
    var s0, s1;
    s0 = [];
    s1 = peg$parseWhiteSpace();

    if (s1 === peg$FAILED) {
      s1 = peg$parseLineTerminatorSequence();

      if (s1 === peg$FAILED) {
        s1 = peg$parselineComment();
      }
    }

    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parseWhiteSpace();

      if (s1 === peg$FAILED) {
        s1 = peg$parseLineTerminatorSequence();

        if (s1 === peg$FAILED) {
          s1 = peg$parselineComment();
        }
      }
    }

    return s0;
  }

  function peg$parselineComment() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 59) {
      s1 = peg$c135;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c136);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$currPos;
      peg$silentFails++;
      s5 = peg$parseLineTerminator();
      peg$silentFails--;

      if (s5 === peg$FAILED) {
        s4 = void 0;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }

      if (s4 !== peg$FAILED) {
        if (input.length > peg$currPos) {
          s5 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s5 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c43);
          }
        }

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$currPos;
        peg$silentFails++;
        s5 = peg$parseLineTerminator();
        peg$silentFails--;

        if (s5 === peg$FAILED) {
          s4 = void 0;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }

        if (s4 !== peg$FAILED) {
          if (input.length > peg$currPos) {
            s5 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s5 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c43);
            }
          }

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLineTerminator() {
    var s0;

    if (peg$c137.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c138);
      }
    }

    return s0;
  }

  function peg$parseLineTerminatorSequence() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 10) {
      s0 = peg$c140;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c141);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c142) {
        s0 = peg$c142;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c143);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 13) {
          s0 = peg$c144;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c145);
          }
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c139);
      }
    }

    return s0;
  }

  function peg$parsePSEUDO_ALIGN() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 6) === peg$c146) {
      s1 = peg$c146;
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c147);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_BYTE() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 5) === peg$c148) {
      s1 = peg$c148;
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c149);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c150();
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_WORD() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 5) === peg$c151) {
      s1 = peg$c151;
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c152);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c153();
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_BINARY() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 7) === peg$c154) {
      s1 = peg$c154;
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c155);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_LET() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 4) === peg$c156) {
      s1 = peg$c156;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c157);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_MACRO() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 6) === peg$c158) {
      s1 = peg$c158;
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c159);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_IF() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 3) === peg$c160) {
      s1 = peg$c160;
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c161);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_ELSE() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 4) === peg$c162) {
      s1 = peg$c162;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c163);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_ELIF() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 4) === peg$c164) {
      s1 = peg$c164;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c165);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_ERROR() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 6) === peg$c166) {
      s1 = peg$c166;
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c167);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_FOR() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 4) === peg$c168) {
      s1 = peg$c168;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c169);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_INCLUDE() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 8) === peg$c170) {
      s1 = peg$c170;
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c171);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_FILL() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 5) === peg$c172) {
      s1 = peg$c172;
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c173);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_USE() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 4) === peg$c174) {
      s1 = peg$c174;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c175);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_FILESCOPE() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 10) === peg$c176) {
      s1 = peg$c176;
      peg$currPos += 10;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c177);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_SEGMENT() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 8) === peg$c178) {
      s1 = peg$c178;
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c179);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_BREAK() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 6) === peg$c180) {
      s1 = peg$c180;
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c181);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePSEUDO_STATEMENT() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c182) {
      s1 = peg$c182;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c183);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLBRK() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 91) {
      s1 = peg$c184;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c185);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseRBRK() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 93) {
      s1 = peg$c187;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c188);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLPAR() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 40) {
      s1 = peg$c189;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c190);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseRPAR() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 41) {
      s1 = peg$c191;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c192);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLWING() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c193;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c194);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseRWING() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 125) {
      s1 = peg$c195;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c196);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDOT() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 46) {
      s1 = peg$c92;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c93);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePTR() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c197) {
      s1 = peg$c197;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c198);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseINC() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c199) {
      s1 = peg$c199;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c200);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDEC() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c201) {
      s1 = peg$c201;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c202);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseAND() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 38) {
      s1 = peg$c203;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c204);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c205.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c206);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSTAR() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 42) {
      s1 = peg$c207;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c208);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePLUS() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 43) {
      s1 = peg$c24;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c25);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c211.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c212);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseMINUS() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 45) {
      s1 = peg$c213;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c214);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c215.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c216);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTILDA() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 126) {
      s1 = peg$c217;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c218);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseBANG() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 33) {
      s1 = peg$c219;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c220);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDIV() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 47) {
      s1 = peg$c221;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c222);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseMOD() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 37) {
      s1 = peg$c87;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c88);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c223.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c224);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLEFT() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c225) {
      s1 = peg$c225;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c226);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseRIGHT() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c227) {
      s1 = peg$c227;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c228);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLT() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 60) {
      s1 = peg$c229;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c230);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseGT() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 62) {
      s1 = peg$c231;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c232);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLE() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c233) {
      s1 = peg$c233;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c234);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseGE() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c235) {
      s1 = peg$c235;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c236);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseEQUEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c237) {
      s1 = peg$c237;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c238);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseBANGEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c239) {
      s1 = peg$c239;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c240);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseHAT() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 94) {
      s1 = peg$c241;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c242);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseOR() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 124) {
      s1 = peg$c243;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c244);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c209.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c210);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseANDAND() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c245) {
      s1 = peg$c245;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c246);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseOROR() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c247) {
      s1 = peg$c247;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c248);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseQUERY() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 63) {
      s1 = peg$c249;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c250);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseCOLON() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 58) {
      s1 = peg$c10;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c11);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (peg$c251.test(input.charAt(peg$currPos))) {
        s3 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c252);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSEMI() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 59) {
      s1 = peg$c135;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c136);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseELLIPSIS() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 3) === peg$c253) {
      s1 = peg$c253;
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c254);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseEQU() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 61) {
      s1 = peg$c255;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c256);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;

      if (input.charCodeAt(peg$currPos) === 61) {
        s3 = peg$c255;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c256);
        }
      }

      peg$silentFails--;

      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsews();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c186(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSTAREQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c257) {
      s1 = peg$c257;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c258);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDIVEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c259) {
      s1 = peg$c259;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c260);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseMODEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c261) {
      s1 = peg$c261;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c262);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePLUSEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c263) {
      s1 = peg$c263;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c264);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseMINUSEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c265) {
      s1 = peg$c265;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c266);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLEFTEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 3) === peg$c267) {
      s1 = peg$c267;
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c268);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseRIGHTEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 3) === peg$c269) {
      s1 = peg$c269;
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c270);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseANDEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c271) {
      s1 = peg$c271;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c272);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseHATEQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c273) {
      s1 = peg$c273;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c274);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseOREQU() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c275) {
      s1 = peg$c275;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c276);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseCOMMA() {
    var s0, s1, s2;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 44) {
      s1 = peg$c277;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c278);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsews();

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c186(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseEOT() {
    var s0, s1;
    s0 = peg$currPos;
    peg$silentFails++;

    if (input.length > peg$currPos) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c43);
      }
    }

    peg$silentFails--;

    if (s1 === peg$FAILED) {
      s0 = void 0;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  var ast = require('./ast');

  var objectToAst = ast.objectToAst;
  var emptyInsn = {
    mnemonic: null,
    imm: null,
    abs: null,
    absx: null,
    absy: null,
    absind: null,
    indx: null,
    indy: null
  };

  function mkinsn(mnemonic, imm, abs, loc) {
    return _objectSpread(_objectSpread({}, emptyInsn), {}, {
      mnemonic: mnemonic,
      imm: imm,
      abs: abs,
      loc: loc
    });
  }

  function mkabsx(mnemonic, absx, loc) {
    return _objectSpread(_objectSpread({}, emptyInsn), {}, {
      mnemonic: mnemonic,
      absx: absx,
      loc: loc
    });
  }

  function mkabsy(mnemonic, absy, loc) {
    return _objectSpread(_objectSpread({}, emptyInsn), {}, {
      mnemonic: mnemonic,
      absy: absy,
      loc: loc
    });
  }

  function mkindx(mnemonic, indx, loc) {
    return _objectSpread(_objectSpread({}, emptyInsn), {}, {
      mnemonic: mnemonic,
      indx: indx,
      loc: loc
    });
  }

  function mkindy(mnemonic, indy, loc) {
    return _objectSpread(_objectSpread({}, emptyInsn), {}, {
      mnemonic: mnemonic,
      indy: indy,
      loc: loc
    });
  }

  function mkabsind(mnemonic, absind, loc) {
    return _objectSpread(_objectSpread({}, emptyInsn), {}, {
      mnemonic: mnemonic,
      absind: absind,
      loc: loc
    });
  }

  function extractList(list, index) {
    return list.map(function (element) {
      return element[index];
    });
  }

  function buildList(head, tail, index) {
    return [head].concat(extractList(tail, index));
  }

  function loc() {
    return _objectSpread(_objectSpread({}, location()), {}, {
      source: options.source
    });
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
  }
}

module.exports = {
  SyntaxError: peg$SyntaxError,
  parse: peg$parse
};